import { Banner, Button } from "@validereinc/common-components";
import classNames from "classnames/bind";
import React from "react";
import styles from "./WorkerDetailPreviousVersionBanner.module.scss";

const cx = classNames.bind(styles);

type WorkerDetailPreviousVersionBannerProps = {
  currentVersionNumber?: number;
  hasLatestVersion: boolean;
  onViewCurrent: () => void;
};

export const WorkerDetailPreviousVersionBanner = ({
  currentVersionNumber,
  hasLatestVersion,
  onViewCurrent,
}: WorkerDetailPreviousVersionBannerProps) => {
  if (currentVersionNumber == null) {
    return null;
  }

  return (
    <Banner
      variant="generic"
      className={cx("banner")}
      titleText={`You are viewing a previous version (v${currentVersionNumber}) of this worker.`}
      actionContent={
        <Button
          variant="text"
          type="button"
          disabled={!hasLatestVersion}
          onClick={onViewCurrent}
        >
          View Current
        </Button>
      }
    />
  );
};
